import { createSlice } from '@reduxjs/toolkit'
import { setChartClosed, setDarkMode, setFullScreen, setUtc } from '../reducers/appReducers'
export type AppState = {
  isFullScreen: boolean
  isUtc: boolean
  isChartOpen: boolean
  isDarkMode: boolean
}

const initialState: AppState = {
  isFullScreen: false,
  isUtc: false,
  isChartOpen: true,
  isDarkMode: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFullScreen,
    setUtc,
    setChartClosed,
    setDarkMode,
  },
})

export const appActions = appSlice.actions
export default appSlice.reducer
